export default class PurchaseOrderOptions{
    constructor({ignoreReserveTargets=false}={}){
        this.ignoreReserveTargets = ignoreReserveTargets;
    }
};